import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';

const StudentFiltersForm = ({
    studyCycle,
    studyCycles,
    faculty,
    studyProgram,
    studyPrograms,
    studyYear,
    studyYears,
    onlyGraduates,
    handleInputChange
}) => (
    <React.Fragment>
        <Form.Group widths="three">
            <Form.Field>
                <label htmlFor="studyCycle">Ciklus studija</label>
                <Form.Select
                    id="studyCycle"
                    value={studyCycle}
                    onChange={handleInputChange}
                    name="studyCycle"
                    options={studyCycles}
                    search
                    fluid
                    clearable
                    placeholder="Odaberite ciklus studija"
                    disabled={!faculty}
                />
            </Form.Field>
            <Form.Field>
                <label htmlFor="studyProgram">Studijski program</label>
                <Form.Select
                    id="studyProgram"
                    value={studyProgram}
                    onChange={handleInputChange}
                    name="studyProgram"
                    options={studyPrograms}
                    search
                    fluid
                    clearable
                    placeholder="Odaberite studijski program"
                    disabled={!faculty}
                />
            </Form.Field>
            <Form.Field>
                <label htmlFor="studyYear">Godina studija</label>
                <Form.Select
                    id="studyYear"
                    value={studyYear}
                    onChange={handleInputChange}
                    name="studyYear"
                    options={studyYears}
                    search
                    fluid
                    clearable
                    placeholder="Odaberite godinu studija"
                    disabled={!faculty || onlyGraduates}
                />
            </Form.Field>
        </Form.Group>
        <Form.Group widths="three">
            <Form.Field>
                <Form.Checkbox
                    label="Samo apsolventi"
                    name="onlyGraduates"
                    checked={onlyGraduates}
                    onChange={handleInputChange}
                    disabled={!faculty}
                />
            </Form.Field>
            <Form.Field />
            <Form.Field />
        </Form.Group>
    </React.Fragment>
);

StudentFiltersForm.propTypes = {
    studyCycle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    studyCycles: PropTypes.arrayOf(PropTypes.object).isRequired,
    faculty: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    studyProgram: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    studyPrograms: PropTypes.arrayOf(PropTypes.object).isRequired,
    studyYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    studyYears: PropTypes.arrayOf(PropTypes.object).isRequired,
    onlyGraduates: PropTypes.bool.isRequired,
    handleInputChange: PropTypes.func.isRequired
};

StudentFiltersForm.defaultProps = {
    studyCycle: '',
    faculty: '',
    studyProgram: '',
    studyYear: ''
};

export default StudentFiltersForm;




// WEBPACK FOOTER //
// ./src/views/GenerateUsers/StudentFiltersForm.js